module.exports = require("react-intl");